export default "__VITE_ASSET__ByV5OE3E__"